import './imageStyle.scss';

const ImageStyle = ({ imageURL, onClick }) => {
  return <div className="image-container" onClick={onClick}>
    <img src={imageURL} alt="MediaImage" />
  </div>
}

export default ImageStyle;
